export default "__VITE_ASSET__CP$apBWY__"